module.exports = __webpack_public_path__ + "media/images/curriculum_4-c16cd6e1981f839685cefdee84353258.png";